const { normalize } = require('./normalize');

const pageTypes = {
  HOME: 'home',
  GAME_HUB: 'game_hub',
  TIER_LIST_HUB: 'tier_list_hub',
  TIER_LIST_EDITOR: 'tier_list_editor',
  GAME_MODE: 'game_mode',
  SAVED_TIER_LIST: 'saved_tier_list',
  POST_HUB: 'post_hub',
  POST: 'post',
  GUIDE_BUILDER: 'guide_builder',
  PAGE: 'page',
  USER: 'user',
  ENTITY_HUB: 'entity_hub',
  ENTITY: 'entity',
  PATCH_HUB: 'patch_hub',
  PATCH: 'patch',
  TIER_LIST_MAKER: 'tier_list_maker',
  NOT_FOUND: 'not_found'
};

// eslint-disable-next-line no-multi-assign
const routes = {
  GameHub: game => {
    return `/${normalize.hyphenateAndLowerCase(game)}/`;
  },

  TierListHub: game => {
    return `/${normalize.hyphenateAndLowerCase(game)}/tier-list/`;
  },

  TierListEditor: game => {
    return `/${normalize.hyphenateAndLowerCase(game)}/tier-list/create/`;
  },

  EditTierList: (game, permalink) => {
    return `/${normalize.hyphenateAndLowerCase(`${game}/tier-list/`)}${permalink}/edit/`;
  },

  GuideBuilder: game => {
    return `/${normalize.hyphenateAndLowerCase(game)}/guide-builder/`;
  },

  GameMode: (game, modeName) => {
    return `/${normalize.hyphenateAndLowerCase(`${game}/${modeName}`)}/`;
  },

  SavedTierList: (game, permalink) => {
    return `/${normalize.hyphenateAndLowerCase(`${game}/tier-list/${permalink}`)}/`;
  },

  PostHub: game => {
    if (game) {
      return `/${normalize.hyphenateAndLowerCase(`${game}/news`)}/`;
    }
    return `/${normalize.hyphenateAndLowerCase(`news`)}/`;
  },

  Post: (game, title) => {
    if (game) {
      return `/${normalize.hyphenateAndLowerCase(`${game}/news/${title}`)}/`;
    }
    return `/${normalize.hyphenateAndLowerCase(`${`news/${title}`}`)}/`;
  },

  Page: (game, title) => {
    if (game) {
      return `/${normalize.hyphenateAndLowerCase(`${game}/${title}`)}/`;
    }
    return `/${normalize.hyphenateAndLowerCase(`${title}`)}/`;
  },

  UnknownPage: () => {
    return `/404/`;
  },

  User: name => {
    const nameWithSpacesTransformed = name && name.replace(/\s/g, '_');
    return `/user/${normalize.hyphenateAndLowerCase(nameWithSpacesTransformed)}/`;
  },

  EntityHub: (game, entityType) => {
    return `/${normalize.hyphenateAndLowerCase(`${game}/${entityType}`)}/`;
  },

  Entity: (game, entityType, entityName) => {
    return `/${normalize.hyphenateAndLowerCase(`${game}/${entityType}/${entityName}`)}/`;
  },

  TierListMaker: () => {
    return `/tier-list-maker/`;
  },

  PatchHub: game => {
    return `/${normalize.hyphenateAndLowerCase(game)}/patch-notes/`;
  },

  Patch: (game, version) => {
    return `/${normalize.hyphenateAndLowerCase(`${game}/patch-notes/${version}`)}/`;
  }
};

module.exports = {
  routes,
  pageTypes
};
